<template>
  <div class="editorComment_container">
    <el-select v-show="users.length" @visible-change="visibleChange" @change='selectChange'
      :class="'select_warp_' + cid" v-model="user" size="mini" clearable placeholder="请选择">
      <el-option v-for="item in users" :key="item[1]" :label="item[0]" :value="item[1]">
      </el-option>
    </el-select>
    <div :style="disabled ? '' : 'background:#F5F7FA;'" class="editorComment_warp">
      <div ref="editor" class="editorComment"></div>
    </div>
  </div>
</template>

<script>
import Quill from "quill";
import "quill/dist/quill.snow.css";
import { postUploadImg } from "@/server/tops/devOps";
export default {
  name: "EditorComment",
  props: {
    content: {
      type: String,
      default: () => {
        return "";
      },
    },
    placeholder: {
      type: String,
      default: () => {
        return "";
      },
    },
    disabled: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    commentStyle: {
      type: String,
      default: () => {
        return "";
      },
    },
    cid: {
      type: [String, Number],
      default: () => {
        return '';
      },
    },
    config: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      fileReader: null,
      fileList: [],
      quill: null,
      msg: "",
      options: {
        theme: "snow",
        modules: {
        },
      },
      user: '',
      visibleSelect: false,
      users: [],
      oldUsers: [],
      searchText: '',
      uploadAPI: "https://devops-test.ehsy.com/devops/common/upload",
    };
  },
  created() {
    let users = []
    for (const key in this.config['TEXTUSERS']) {
      users.push([`${this.config['TEXTUSERS'][key]}（${key}）`, key])
    }
    this.users = users;
    this.oldUsers = JSON.parse(JSON.stringify(users))
  },
  methods: {
    visibleChange(val) {
      this.visibleSelect = val;
    },
    selectChange(val) {
      const length = this.quill.getSelection(true);
      this.quill.insertText(length, val + ' ')
      this.quill.deleteText(length.index - this.searchText.length, this.searchText.length)
      this.quill.insertText(length.index - this.searchText.length - 1, ' ')
      this.$emit('commentData', { text: this.quill.root.innerHTML, cid: this.cid, show: true });
      this.$nextTick(() => {
        this.quill.setSelection(length);
        this.user = ''
        this.searchText = ''
      });
    },
    formatSelect(html) {
      html = html.substring(html.lastIndexOf("\@") + 1, html.length);
      if (html.indexOf(' ') == -1) {
        html = html.split('</p>')[0];
        this.user = html;
        this.searchText = html;
        if (html) {
          this.users = this.oldUsers.filter(item => {
            return item[0].toLocaleUpperCase().includes(html.toLocaleUpperCase())
          })
        } else {
          this.users = this.oldUsers;
        }
      }
    },
  },
  async mounted() {
    this.fileReader = new FileReader();
    const dom = this.$el.querySelector(".editorComment");
    this.quill = new Quill(dom, this.options);
    this.quill.root.innerHTML = this.content;
    this.quill.enable(this.disabled);
    this.quill.root.dataset.placeholder = this.placeholder;
    this.quill.on("text-change", async (delta, oldDelta, source) => {
      // console.log(delta,delta.ops[1], oldDelta, source, this.quill.root.innerHTML)
      if (delta?.ops[0]?.insert?.image || delta?.ops[1]?.insert?.image) {
        const dataurl =
          delta?.ops[0]?.insert?.image || delta?.ops[1]?.insert?.image;
        if (dataurl.startsWith("data:")) {
          const ret = await postUploadImg({ img: dataurl });
          if (ret?.data?.url) {
            this.quill.root.innerHTML = this.quill.root.innerHTML.replace(
              dataurl,
              ret?.data?.url
            ).replace(/<img src=/g, `<img style="width:200px;height:100px;cursor:pointer;" onClick="window.open('${ret?.data?.url}')" src=`);
          }
        }
      }
      this.formatSelect(this.quill.root.innerHTML)
      this.$nextTick(() => {
        this.quill.setSelection(this.quill?.getSelection()?.index || this.quill.root.innerHTML.length);
      });
      if ((((delta.ops[1] && delta.ops[1].insert === '@') || this.quill.root.innerHTML === '<p>@</p>') && !this.visibleSelect)) {
        this.users = this.oldUsers;
        document.getElementsByClassName("select_warp_" + this.cid)[0].click();
      } else if (this.quill.root.innerHTML === '<p><br></p>' && this.visibleSelect) {
        document.getElementsByClassName("select_warp_" + this.cid)[0].click();
      }
      else {
        if (this.quill.root.innerHTML === '<p><br></p>') {
          this.quill.root.innerHTML = ''
        }
        if (!this.cid) {
          this.$emit('commentData', { text: this.quill.root.innerHTML, cid: '', show: delta.ops[0].delete !== 1 });
        } else {
          this.$emit('commentData', { text: this.quill.root.innerHTML, cid: this.cid, show: delta.ops[0].delete !== 1 });
        }
      }

    });
  },
  computed: {
    newUsers: function (newVal, oldVal) {
      return this.users
    }
  },
  watch: {
    disabled: {
      deep: true, //true为进行深度监听,false为不进行深度监听
      handler(newVal) {
        this.quill.enable(newVal);
      },
    },
    content: {
      deep: true, //true为进行深度监听,false为不进行深度监听
      handler(newVal) {
        const length = this.quill.getSelection(true);
        this.quill.root.innerHTML = newVal;
        this.$nextTick(() => {
          if (length) {
            this.quill.setSelection(length.index);
          }
        });
      },
    },
  },
};
</script>
<style lang="scss">
.editorComment_container {
  width: 100%;

  .el-select {
    opacity: 0;
    width: 0;
    height: 0;
    float: left;
    overflow: hidden;
  }
}

.editorComment_warp {
  width: 100%;

  .ql-toolbar {
    display: none;
  }

  .ql-container.ql-snow {
    border: none;
  }

  .editorComment {
    .ql-editor {
      min-height: 30px;
      font-size: 14px;
      border: 1px solid #ccc;
      padding: 5px;
      width: 100%;
      border-radius: 4px;
    }
  }
}
</style>
